import { render, staticRenderFns } from "./counter-checkout.vue?vue&type=template&id=fc1dc868&scoped=true"
import script from "./counter-checkout.vue?vue&type=script&lang=js"
export * from "./counter-checkout.vue?vue&type=script&lang=js"
import style0 from "./counter-checkout.vue?vue&type=style&index=0&id=fc1dc868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1dc868",
  null
  
)

export default component.exports